"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var Cards = function (_a) {
    var channel = _a.channel, onShare = _a.onShare, setModal = _a.setModal, closeModal = _a.closeModal, user = _a.user;
    var _b = ra_fetch_1.useApi('backend').index('livestreams', { channel_id: channel.id, details: true }), livestreams = _b[0], setLivestreams = _b[1];
    if (livestreams.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!livestreams.data.length) {
        return react_1.default.createElement(storybook_1.Forms.New, { description: 'Je hebt nog geen livestreams', label: 'Nieuwe livestream', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/livestreams/create", icon: 'plus' });
    }
    function onDelete(livestream) {
        setModal({
            content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { title: 'livestream', route: 'livestreams', api: 'backend', records: livestreams.data, onDelete: closeModal, setRecords: setLivestreams, params: { id: livestream.id, channel_id: channel.id } }); },
        });
    }
    return react_1.default.createElement(storybook_1.Grids.List, null, livestreams.data.map(function (livestream, index) { return react_1.default.createElement(storybook_1.Cards.Card, { key: index, className: 'flex flex-col justify-between' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'flex justify-between' },
                react_1.default.createElement(storybook_1.Texts.Primary, null, livestream.name),
                react_1.default.createElement("div", { className: 'flex items-center' },
                    livestream.status === 'idle' && react_1.default.createElement(storybook_1.Texts.Badge, { type: 'idle' }, "IDLE"),
                    livestream.status === 'active' && react_1.default.createElement(storybook_1.Texts.Badge, { type: 'live' }, "LIVE"),
                    user.permissions.includes('api.livestreams.destroy') &&
                        react_1.default.createElement(storybook_1.Buttons.Button, { className: 'ml-4', onClick: function () { return onDelete(livestream); } },
                            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon text-disabled' })))),
            livestream.teams &&
                react_1.default.createElement(storybook_1.Texts.Secondary, null, livestream.teams)),
        react_1.default.createElement(storybook_1.Cards.Buttons, null,
            user.permissions.includes('api.livestreams.update') &&
                react_1.default.createElement(storybook_1.Cards.Button, { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/livestreams/" + livestream.id + "/edit" },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'pencil', className: 'storybook-icons-icon' }),
                    "Bewerken"),
            react_1.default.createElement(storybook_1.Cards.Button, { onClick: function () { return onShare(livestream); } },
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'share', className: 'storybook-icons-icon' }),
                "Delen"))); }));
};
exports.Cards = Cards;
